module.exports = __webpack_public_path__ + "img/c08_unittechdharma_Normal_ua.2dbc2743.webp";